import { useContext } from 'react';
import TourContext from 'contexts/TourContext';

// Hook to use tour context
const useTour = () => {
  const context = useContext(TourContext);

  if (!context) {
    throw new Error('useTour must be used within a TourProvider');
  }

  return context;
};

export default useTour;
